<app-sor-table [data]="users" [columns]="tableSettings"></app-sor-table>
